













import {Component, Vue} from 'vue-property-decorator'
import mock from '../../mock/Paper';

@Component
export default class Papers extends Vue {
  private content: string = '';
  private targetName: string = 'succ_papers';

  private mounted() {
    this.getContent();
  }

  private getContent() {
    this.content = mock.Paper;
    //  const loadInstance = Loading.service({target: '.ql-editor'});
    // $api.module.findContentByName(this.targetName)
    // .then((res) => {
    //     this.content = (res as any).content;
    //     loadInstance.close();
    // }).catch((error) => {
    //     loadInstance.close();
    //     Notification({
    //         title: '网络异常',
    //         message: error,
    //         type: 'error',
    //     });
    // })
  }
}
